import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/de/admin')({
  component: Outlet,
})
